import { render } from "./Items.vue?vue&type=template&id=ab3772f4&scoped=true"
import script from "./Items.vue?vue&type=script&lang=js"
export * from "./Items.vue?vue&type=script&lang=js"

import "./Items.vue?vue&type=style&index=0&id=ab3772f4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ab3772f4"

export default script